import { useTranslation } from 'react-i18next';
import { S, Icon, Icons } from '../regureStyles';
import PermissionGate from '../../components/PermissionGate';

const Header = ({ history, setShowGenModal, carriers }) => {
  const { t } = useTranslation();
  return (
    <header
      style={{
        padding: '20px 32px',
        borderBottom: `1px solid ${S.borderLight}`,
        background: 'rgba(255,255,255,0.85)',
        backdropFilter: 'blur(20px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
      }}
    >
      <div>
        <div style={{ fontSize: 12, color: S.textMuted, display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
          {t('screens.bordereaux.breadcrumbOps')} {Icons.chevronRight(S.textMuted, 12)} <span style={{ color: S.textPrimary, fontWeight: 500 }}>{t('screens.bordereaux.breadcrumbCurrent')}</span>
        </div>
        <div style={{ fontSize: 22, fontWeight: 700, color: S.textPrimary }}>{t('screens.bordereaux.title')}</div>
      </div>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
        <PermissionGate resource='riskCarriers' action='read'>
          <button
            onClick={() => history.push('/risk-carriers')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              padding: '9px 16px',
              background: S.bgCard,
              border: `1px solid ${S.borderLight}`,
              borderRadius: 10,
              fontSize: 13,
              fontWeight: 500,
              color: S.textSecondary,
              cursor: 'pointer',
            }}
          >
            <Icon name='building' color={S.textMuted} size={15} /> {t('screens.bordereaux.carriers')}
          </button>
        </PermissionGate>
        <PermissionGate resource='bordereaux' action='generate'>
          <button
            onClick={() => {
              setShowGenModal(true);
            }}
            disabled={carriers.length === 0}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              padding: '9px 16px',
              background: `linear-gradient(135deg, ${S.burgundy}, ${S.burgundy2})`,
              color: '#fff',
              border: 'none',
              borderRadius: 10,
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
              opacity: carriers.length === 0 ? 0.5 : 1,
            }}
          >
            <Icon name='plus' color='#fff' size={16} /> {t('screens.bordereaux.generateReport')}
          </button>
        </PermissionGate>
      </div>
    </header>
  );
};

export default Header;
